import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import React from 'react'
import PropTypes from 'prop-types'

import * as selectors from '../preloader.selectors'
/**
 *  loading Bar
 */
const LoadingBar = ({ remaining, toLoadCount, preloaderSettings }) => {
  const { textElement, progressElement, loadingBar } = preloaderSettings
  let percent = Math.floor(((toLoadCount - remaining) * 100.0) / toLoadCount) || 0
  percent = percent > 100 ? 100 : percent
  const style = { width: percent + '%' }

  return (
    <div className="loader">
      <div className={progressElement} style={loadingBar ? style : {}}></div>
      <div className={textElement}>
        <p>
          <b>
            <FormattedMessage id={'loading'} values={{ percent: percent }} />
          </b>
        </p>
      </div>
    </div>
  )
}

LoadingBar.propTypes = {
  preloaderSettings: PropTypes.object,
  remaining: PropTypes.number,
  toLoadCount: PropTypes.number,
}

/**
 *  map state to props
 */
function mapStateToProps(state) {
  return {
    preloaderSettings: selectors.getPreloaderSettings(state),
    remaining: selectors.getProgress(state),
    toLoadCount: selectors.getToPreloadItemsCount(state),
  }
}

export default connect(mapStateToProps, null)(LoadingBar)
